module.exports = __webpack_public_path__ + "img/特种证书复审@3x.880f5b8e.png";